import { render, staticRenderFns } from "./nav-box.vue?vue&type=template&id=ad8c4ae8&scoped=true&"
import script from "./nav-box.vue?vue&type=script&lang=ts&"
export * from "./nav-box.vue?vue&type=script&lang=ts&"
import style0 from "./nav-box.vue?vue&type=style&index=0&id=ad8c4ae8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8c4ae8",
  null
  
)

export default component.exports